import Model from './Model'

export default class Program extends Model {
  resource() {
    return 'admin/programs'
  }
}
